module.exports = __webpack_public_path__ + "img/1483330198.2fa6e093.jpg";